__webpack_require__.p = "/Mini-E-Commerce-Site/";